<template>
  <OnboardingWrapper>
  <div class="game-detail-surveys">
    <div>
      <transition name="fade">
        <Loading v-if="isLoading"></Loading>
      </transition>
    </div>
    <template v-if="resultVisible">
      <Results @toDetailAnalysisChild="toDetailAnalysis"></Results>
    </template>
    <template v-if="mainVisible">
      <div class="gda-survey-box">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-clipboard-data gda-icon"
          viewBox="0 0 16 16"
        >
          <path
            d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z"
          />
          <path
            d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
          />
          <path
            d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
          />
        </svg>
        <h3 class="gda-text">Surveys</h3>
        <button class="survey-btn-add" v-on:click="newSurvey()">
          Add New Survey
        </button>
        <hr class="divider" />
        <div class="gda-survey-list">
          <div v-for="item in surveyObj" class="gda-survey">
            <div class="gda-text-container">
              <div class="survey-title" v-if="item.name">{{ item.name }}</div>
              <div class="survey-title" v-else>No Name</div>
              <div class="new-text" v-if="item.status === 0 && !item.feedback">New</div>
              <div class="new-text" v-if="item.status === 0 && item.feedback">Revision Requested</div>
              <div class="new-text" v-if="item.status === 3">Pending Approval</div>
              <div class="new-text" v-if="item.status === 4">Approved</div>
              <div class="new-text" v-if="item.status === 5">Unpublished</div>
              <p v-if="item.status === 1">{{ item.responses }}Published</p>
              <p v-if="item.status === 2">{{ item.responses }}Archived</p>
            </div>
            
            <div class="button-container">
              <button
                class="survey-btn"
                v-if="item.status === 0"
                v-on:click="editSurvey(item)"
              >
                Edit
              </button>
              <button
                class="survey-btn"
                v-if="item.status === 5"
                v-on:click="editSurvey(item)"
              >
                Edit
              </button>
              <div class="survey-title" v-if="item.status === 5">Flagged <span>⚑</span></div>
              <button 
                class="survey-btn" 
                v-if="item.status === 0 && item.feedback" 
                v-on:click="showFeedback(item)"
              >
                Feedback
              </button>
              <!-- <button
                class="survey-btn"
                v-if="item.status === 0"
                v-on:click="submitSurvey(item)"
              >
                Submit
              </button> -->
              <button
                class="survey-btn"
                v-if="item.status === 3"
                v-on:click="cancelSurvey(item)"
              >
                Cancel
              </button>
              <button
                class="survey-btn"
                v-if="item.status === 4"
                v-on:click="publishSurvey(item)"
              >
                Publish
              </button>
              <button
                class="survey-btn"
                v-if="item.status === 1 || item.status === 2"
                v-on:click="viewResults(item)"
              >
                Testers
              </button>
              <button
                class="survey-btn"
                v-if="item.status === 1 || item.status === 2"
                v-on:click="viewDetails(item)"
              >
                Details
              </button>
              <button
                class="survey-btn"
                v-if="item.status === 1 || item.status === 2"
                v-on:click="viewResults(item)"
              >
                Results
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- This is a detail container that is able to hold any other component, we swap out the displayed component depending on
    the button clicked, or currentContentType -->
    <DetailContainer
      :key="this.displayedSurvey==null ? (this.currentContentType + 'none') : (this.currentContentType + this.displayedSurvey.sID)"
      :contentType="currentContentType"
      :survey-obj="displayedSurvey"
      v-if="mainVisible"
    ></DetailContainer>
  </div>
  </OnboardingWrapper>
</template>

<script>
import Results from "./Surveys/Results.vue";
import DetailContainer from "./Surveys/DetailContainer.vue";
import Template from "../../Firestore/Template.js";
import Response from "../../Firestore/Response.js";
import Notifications from "../../Firestore/Notifications.js";
import Chat from "../../Firestore/Chat.js";
import testSessionItem from "./TestSessionItem.vue";
import Loading from "../loading/index.vue";
import Accordion from "../survey-reporting/TextAccordion.vue";
import VueBarGraph from "vue-bar-graph";
import BarChart from "../survey-reporting/BarChart.vue";
import OnboardingWrapper from '../onboarding/OnboardingWrapper.vue';
import { onboardingService } from '@/services/OnboardingService';
import { initializePageOnboarding } from '@/services/onboardingConfigs';
export default {
  name: "gameDetailSurveys",
  components: {
    testSessionItem,
    Loading,
    Accordion,
    VueBarGraph,
    BarChart,
    Results,
    DetailContainer,
    OnboardingWrapper
  },
  props: {
    detail: {
      type: Object
    }
  },
  data() {
    return {
      userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1, // 0: Tester, 1: Company, 2: Admin
      unsubscribe: null,
      surveyObj: [],
      mainVisible: true,
      isLoading: false,
      resultVisible: false,
      barChartData: [12, 19, 3, 5, 2, 3],
      //sessions: [],
      //visibleNotes: null,
      displayedSurvey: null,
      currentContentType: 'none',
    };
  },
  mounted() {
    this.unsubscribe = Template.watchSurveysByGameID(window.localStorage.getItem("gameId"), res => {
      this.surveyObj = res.data;
    });
    if (this.userType === 1) {
    this.$nextTick(() => {
      initializePageOnboarding(
        'survey',
        this.userType,       
        onboardingService,
        this.$store
      );
  });
}
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  },
  methods: {
    newSurvey() {
      this.$router.push({
        name: "editsurvey",
        params: {
          mode: "survey",
          itemId: "new",
        },
      });
    },
    increment(num, max) {
      if (num < max) {
        return num + 1;
      }
    },
    showLoading() {
      this.isLoading = true;
      setTimeout(() => (this.isLoading = false), 200);
    },
    // Go back to main Analysis menu
    toDetailAnalysis() {
      this.showLoading();
      this.mainVisible = true;
      this.resultVisible = false;
    },
    editSurvey(survey) {
      this.$router.push({
        name: "editsurvey",
        params: {
          mode: "survey",
          itemId: survey.sID,
        },
      });
    },
    submitSurvey(survey) {
      // If new, set to pending approval
      if (survey.status === 0) {
        Template.setSurveyStatus(survey.sID, 3)
          .then(async () => {
            let submitterName = null;
            try {
              const res = await Chat.getUserInfo(window.localStorage.getItem("userId"));
              submitterName = res.data.userName || res.data.nickName || null;
            } catch (e) {
              submitterName = null;
            }

            Notifications.createRoleNotification(
              2,
              "survey-approval",
              "New survey to approve!",
              survey.name ? `Survey "${survey.name}" was submitted for approval.` : "",
              {
                surveyId: survey.sID,
                surveyName: survey.name || "Untitled survey",
                projectId: window.localStorage.getItem("gameId") || null,
                projectName: (this.detail && this.detail.gameName) || null,
                submitterName,
              }
            );
            survey.status = 3;
          })
          .catch(e => console.log(e));
      }
    },
    cancelSurvey(survey) {
      // If submitted for approval, set back to new
      if (survey.status === 3) {
        Template.setSurveyStatus(survey.sID, 0)
          .then(() => {
            survey.status = 0;
          })
          .catch(e => console.log(e));
      }
    },
    publishSurvey(survey) {
      // If approved, assign to playtesters and set to published
      if (survey.status === 4) {
        Response.assignSurveyToAll(survey.sID, survey.gameID)
          .then(() => {
            survey.status = 1;
          })
          .catch(e => console.log(e));
      }
    },
    viewResults(survey) {
      // this.mainVisible = false;
      // this.resultVisible = true;
      this.currentContentType = "results";
      this.showLoading();
      this.displayedSurvey = survey;
      console.log(this.displayedSurvey);
    }, // not yet implemented
    viewDetails(survey) {
      // this.mainVisible = false;
      // this.resultVisible = true;
      this.currentContentType = "details";
      this.showLoading();
      this.displayedSurvey = survey;
      console.log(this.displayedSurvey);
    }, // not yet implemented
    showFeedback(survey) {
      this.currentContentType = "feedback";
      this.displayedSurvey = survey;
    }
  },  
};
</script>

<style scoped>
.game-detail-surveys {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
}

.gda-survey-box,
.gda-interviews-box,
.gda-in-game-box {
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  width: 30%;
  height: 75vh;
  margin: 0 2%;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

@media only screen and (max-width: 1330px) {
  .gda-survey-box,
  .gda-interviews-box,
  .gda-in-game-box {
    width: 360px;
  }
}

.gda-icon {
  height: 15%;
  color: #aaa;
  margin: 5%;
}

.gda-text {
  color: #fc7727;
}

.survey-btn,
.survey-btn-add {
  background-color: #fc7727 !important;
  color: #fff;
  border: none;
  border-radius: 10px !important;
  padding: 0.25rem 0.5rem;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
}

.survey-btn-add {
  width: 75%;
  margin-bottom: 3%;
  padding: 1%;
}
.divider {
  border: 1px solid #c2c2c2;
  width: 95%;
  margin: 0 auto;
}
.survey-btn {
  height: fit-content;
}

.survey-btn:hover,
.survey-btn-add:hover {
  background-color: #ff8e4d !important;
}

.gda-survey-list {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  width: 100%;
  align-items: center;
  overflow: auto;
}
.gda-survey-list::-webkit-scrollbar {
  display: none;
}

.gda-survey {
  width: 90%;
  display: flex;
  flex-direction: column;
  background-color: transparent !important;
  border: 1px solid #ccc !important;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0.5rem 1rem;
  border-radius: 15px !important;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.1);
}

.button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: flex-end;
}

.gda-text-container {
  display: flex;
  flex-direction: column;
  width: 60%;
}
.survey-title {
  color: #000 !important;
  font-size: large;
  font-weight: bold;
}

.new-text {
  font-style: italic;
  color: #bebebe;
}

.viewresults-back {
  height: 21px;
  font-size: 16px;
  line-height: 21px;
  text-decoration-line: underline;
  color: #000000;
  margin-bottom: 34px;
  cursor: pointer;
}

#gamedetail-modify {
  position: absolute;
  width: 25%;
  height: 40px;
  right: 0;
  top: 50px;
  background: #fc7727;
  color: var(--GAMEDM);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 5px;
  display: inline-block;
  cursor: pointer;
}

.gamedetail-title {
  margin-top: 40px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 18px;
  line-height: 13px;
  display: flex;
  align-items: center;
}

.gamedetail-content {
  margin-bottom: 5px;
}

.white-text {
  color: #000000;
}

.game-detail-description {
  position: relative;
  margin-right: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/game-detail/GameDetail-Surveys.vue